const getUser = (store) => {
  return {
    user: store.root.userStore.user || {},
  };
};

const getUserAndImages = (store) => {
  return {
    user: store.root.userStore.user || {},
    images: store.root.imagesStore.images || []
  };
};

module.exports = {
  getUser,
  getUserAndImages,
};
